import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query AdminPages($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          pages {
            id
            name
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AdminPagesQuery,
    readonly Pick<ents.core.mosaic.Page, 'id' | 'name'>[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicDev',
        graphql.transformers.OUT.select(
          'pages',
          graphql.transformers.OUT.list(
            graphql.transformers.OUT.object({
              id: transformers.PASS_THROUGH,
              name: graphql.transformers.OUT.default(
                transformers.PASS_THROUGH,
                '',
              ),
            }),
            {
              onNullish: 'remove',
            },
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.AdminPagesQuery,
  readonly Pick<ents.core.mosaic.Page, 'id' | 'name'>[],
  graphql.schema.AdminPagesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
